const loadingType = {
  PLACEHOLDER: {
    key: 'PLACEHOLDER',
    value: 'Placeholder',
  },
  PLAIN_SPINNER: {
    key: 'PLAIN_SPINNER',
    value: 'Plain Spinner',
  },
  CHASE_SPINNER: {
    key: 'CHASE_SPINNER',
    value: 'Chase Spinner',
  },
  BAR_SPINNER: {
    key: 'BAR_SPINNER',
    value: 'Bar Spinner',
  },
  DOT_SPINNER: {
    key: 'DOT_SPINNER',
    value: 'Dot Spinner',
  },
  FADING_CIRCLE_SPINNER: {
    key: 'FADING_CIRCLE_SPINNER',
    value: 'Fading Circle Spinner',
  },
  BOUNCE_SPINNER: {
    key: 'BOUNCE_SPINNER',
    value: 'Bounce Spinner',
  },
  NONE: {
    key: 'NONE',
    value: 'None',
  },
};

export default loadingType;
